export default __webpack_public_path__ + "static/media/callraise_0005_thumb.b4397624.jpg";